var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.94 9.24c.93.94 1.95 1.69 3 2.24l1.97-2 3.57.82c.38.08.7.3.7.7v3.52a.3.3 0 0 1-.24.3c-3.35.7-7.52-.66-10.72-3.86C1.02 7.76-.35 3.59.36.24A.3.3 0 0 1 .66 0h3.53c.38 0 .6.32.7.7l.81 3.57-2 1.97c.55 1.04 1.3 2.07 2.24 3Z",
    clipRule: "evenodd"
  })));
};
export default SvgPhone;